import { forEach } from 'lodash';
import { UserComment } from '../../queries/contentPage/commentList';

export interface CommentTreeNode extends UserComment {
  children?: CommentTreeNode[];
}

export function getUserCommentTree(
  comments: UserComment[],
  parent = 0,
): CommentTreeNode[] {
  const items: CommentTreeNode[] = [];
  forEach(comments, function (comment) {
    if (comment.parent_id === parent) {
      items.push({
        id: comment.id,
        parent_id: comment.parent_id,
        message: comment.message,
        name: comment.name,
        date: comment.date,
        children: getUserCommentTree(comments, comment.id),
      });
    }
  });

  return items;
}
